<template lang="pug">
    v-card(v-if="competition.status !== 'Live'" outlined rounded)
        v-row(no-gutters)
            v-col(cols="12")
                v-card-title
                    h3 {{$t('competition_broker')}}
                v-card-text(class="d-flex justify-content-center")
                    p {{competition.status}}

    v-card(v-else outlined rounded style="position:relative; height:100%;")
        v-row(no-gutters)
            v-col(cols="6")
                v-card-title
                    h3 {{$t('competition_broker')}}
            v-col(cols="6" class="d-flex justify-content-end")
                v-card-title(style="border:0px solid;")
                    v-btn-toggle(mandatory=true v-model="action" color="blue3" small)
                        v-btn(value="BUY" width="100" small) {{$t('buy')}}
                        v-btn(value="SELL" width="100" small) {{$t('sell')}}

        v-row(no-gutters style="height:275px;")
            v-col(cols="6")
                v-card-text(v-if="action === 'BUY'" class="pt-0")
                    BrokerActionBox(:action="action" :user_account_id="competition.user_account_id" :user_id="competition.user_id")
            v-col(cols="6")
                v-card-text(v-if="action === 'SELL'" class="pt-0")
                    BrokerActionBox(:action="action" :user_account_id="competition.user_account_id" :user_id="competition.user_id")

        div(v-if="getTxOrders.length > 0" style="position:absolute; bottom:0; height:170px; width:100%;")
            div
                h3(class="ma-0 pl-2") Orders

            div(class="pl-2") Orders will be made after market close

            
            div(class="ml-1 mr-1 pa-2 pb-0" style="max-height:110px; overflow-y:scroll;")
                table(style="width:100%;")
                    tr
                        td(style="width:120px;")
                            b Stock
                        td(align="right")
                            b Quantity
                        td(style="width:120px;")
                        td(align="right")
                            b Bid Price
                        td(align="right" style="color:lightgrey;")
                            b Order Type
                        td(class="pl-6")
                            b Reserved

                    tr(v-for="order in getTxOrders")
                        td
                            div(class="ticker") {{ getTicker(order.stock_id) }}
                        td(align="right") {{ order.qty }}
                        td(align="right") {{ order.tx_type }}
                        td(align="right") {{ order.price }} {{ order.currency }}
                        td(align="right" style="color:lightgrey;") {{ order.order_type }}
                        td
                            div(class="pl-6" style="float:left;") {{ order.amount_sek }} SEK
                            div(@click="deleteOrder(order.tx_order_id)" class="trashcan-container" style="float:right;")
                                v-icon(class="hover-trash-can") $trashCan
</template>

<script>
import BrokerActionBox from "./BrokerActionBox.vue";
import { mapActions, mapGetters } from "vuex";

export default {
    name: "CompetitionBrokerCard",
    components: {
        BrokerActionBox,
    },
    props: ["competition"],
    data() {
        return {
            action: "BUY"
        };
    },
    watch: {
        async user_account_id() {
            await this.loadTxOrders(this.user_account_id);
        }
    },
    async mounted() {
        await this.loadTxOrders(this.user_account_id);
    },
    computed: {
        ...mapGetters(['getTxOrders', 'getAllStocks']),
        user_account_id() {
            return this.competition.user_account_id;
        }
    },
    methods: {
        ...mapActions(['loadTxOrders', 'deleteTxOrder']),
        getTicker(stock_id) {
            return this.getAllStocks.find((s) => s.stock_id === stock_id).ticker;
        },
        async deleteOrder(tx_order_id) {
            const user_account_id = this.user_account_id;

            const deleteObject = {
                tx_order_id,
                user_account_id
            };

            await this.deleteTxOrder(deleteObject);
        }
    }
};
</script>

<style scoped>
.ticker {
    min-width: 90px;
    background:#1A4D5E;
    color:white;
    border-radius: 3px;
    padding: 3px;
    margin: 2px;
}

>>> .set-trash-can-color {
    stroke: lightgrey;
}

>>> .hover-trash-can:hover .set-trash-can-color {
    stroke: red;
}

.trashcan-container {
    height: 28px;
}

.trashcan-container:hover {
    cursor: pointer;
}
</style>
